<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <!-- <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <svg-icon iconName="logo-small" />
      </router-link> -->
      <!-- <span v-else class="sidebar-logo-link">{{ title }}</span> -->
      <div class="sidebar-logo-link">{{ title }}
        <img class="spread" src="../../../assets/spread.png" alt="">
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    title: String,
    collapse: {
      type: Boolean,
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  background-color: $menuBg;
  text-align: left;
  padding: 23px 20px;
  overflow: hidden;
  border-bottom: 1px solid #DFDFDF;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    color: #323232;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &.collapse {
    .svg-icon {
      width: 21px;
      margin-right: 0;
    }
  }
  .spread {
    width: 14px;
    height: 10px;
  }
}
</style>
